// extracted by mini-css-extract-plugin
export var growableInput = "_50-0";
export var tagContainer = "_50-2";
export var textInput = "_50-1";